import React, { useEffect, useState } from "react"
import LayoutLogout from '../features/_layout/LayoutLogout'
import Auth from "../features/auth/"
import { hasAuthToken, getBearerToken } from '../actions/_auth'
import { REFERENCES_MYSELF } from '../const/api_paths'
import { API_PATH } from '../const/api_paths'

export default () => {
  const [loading, setLoading] = useState(true)
  const [logged_in, setLoggedIn] = useState(false)

  useEffect(() => {
    const checkAuthAndRedirect = async () => {
      if (hasAuthToken() === true) {
        setLoggedIn(true)

        // Fetch user type to determine where to redirect
        try {
          const response = await fetch(API_PATH(REFERENCES_MYSELF), {
            headers: {
              'Authorization': getBearerToken(),
              'Content-Type': 'application/json'
            }
          })

          if (response.ok) {
            const userData = await response.json()
            // Redirect based on user type
            if (userData.user_type === 'client') {
              // The client portal lives in frittata-web; this app is staff-only.
              window.location = 'https://new.frittata.app/portal'
            } else {
              window.location = "/app/all"
            }
          } else {
            // If API call fails, default to app
            window.location = "/app/all"
          }
        } catch (error) {
          console.error('Error fetching user type:', error)
          // If error occurs, default to app
          window.location = "/app/all"
        }
      } else {
        setLoggedIn(false)
        setLoading(false)
      }
    }

    checkAuthAndRedirect()
  }, [])

  if (loading === true) {
    return <span>loading...</span>
  } else if (logged_in === false) {
    return (
      <LayoutLogout>
        <Auth />
      </LayoutLogout>
    )
  } else {
    return <span>Redirecting...</span>
  }
}
